import { useEffect } from "react";

export function getTagAndPageFromPath(path: string) {
    // query params can break our search.
    const pathWithoutQuery = path.split("?")[0];

    // This regex matches:
    // - '/tag/' literally,
    // - followed by one or more characters (that are not a slash) as tagName,
    // - optionally followed by '/page/' and a (possibly negative) number.
    const regex = /\/tag\/([^/]+)(?:\/page\/(-?\d+))?/;
    const match = pathWithoutQuery.match(regex);
    
    if (match) {
    const tagName = match[1];
    // Convert the captured page number to a number; default to 1 if it's missing or invalid.
    let pageNumber = Number(match[2]) || 1;
    // Enforce that pageNumber is at least 1.
    pageNumber = Math.max(pageNumber, 1);
    return { tagName, pageNumber };
    }
    // If no match is found, you might return null or set defaults.
    return { tagName: null, pageNumber: 1 };
}
  
// Helper to update the browser URL.
// If pageNumber is 1, we remove the /page segment.
export function updateUrl(tag: string, pageNumber: number) {
    if (typeof window !== 'undefined' && window.history.pushState) {
      let newPath = `/blog/tag/${tag}`;
      if (pageNumber > 1) {
        newPath += `/page/${pageNumber}`;
      }
      window.history.pushState({}, '', newPath);
  };
}

export function buildPaginationUrl(tag: string, pageNumber: number): string {
    return pageNumber <= 1 ? `/blog/tag/${tag}` : `/blog/tag/${tag}/page/${pageNumber}`;
}
  